import React from "react";
import { useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import RoomData from "../../../interfaces/robot/rooms/room-data";
import { computeAbsolutePositions, listedRoomCardWidthPx } from "../../../utils/floors-graph-helper";

const FloorGraph: React.FC<{ rooms: RoomData[] }> = ({ rooms }) => {
  const theme = useTheme();

  const {
    stations: absoluteStationPositions,
    coordinateX: minWidth,
    coordinateY: minHeight,
  } = computeAbsolutePositions(rooms.filter((r) => r.secondaryStation != null));

  const imageSize = listedRoomCardWidthPx - 12;

  return (
    <React.Fragment>
      <Box style={{ padding: 16 }} width={imageSize} height={imageSize}>
        <svg viewBox={`0 0 ${minWidth + 132} ${minHeight + 132}`} width={imageSize - 32} height={imageSize - 32}>
          {absoluteStationPositions.map((station, index) => {
            const transition = rooms.find(
              (r) =>
                (r.primaryStation.stationId === station.id && r.secondaryStation != null) ||
                r.secondaryStation?.stationId === station.id
            );
            const stationA = absoluteStationPositions.find((s) => s.id === transition?.primaryStation.stationId);
            const stationB = absoluteStationPositions.find((s) => s.id === transition?.secondaryStation?.stationId);
            if (stationA != null && stationB != null) {
              return (
                <line
                  key={`line-${index}`}
                  x1={stationA.coordinateX + 66}
                  y1={stationA.coordinateY + 66}
                  x2={stationB.coordinateX + 66}
                  y2={stationB.coordinateY + 66}
                  stroke={theme.palette.primary.main}
                  strokeWidth={12}
                />
              );
            }
            return null;
          })}

          {absoluteStationPositions.map((station) => (
            <React.Fragment key={station.id}>
              <rect
                x={station.coordinateX + 2}
                y={station.coordinateY + 2}
                width={128}
                height={128}
                fill={station.isTransition ? "rgba(255,255,255,0.5)" : "white"}
                rx={8}
                stroke={"black"}
                strokeWidth={4}
              />
            </React.Fragment>
          ))}
        </svg>
      </Box>
    </React.Fragment>
  );
};

export default FloorGraph;
